import axios from "utils/axiosInstance";
import { AuditLogParam } from "utils/data/audit-logs";

export const getAuditLogs = (params: AuditLogParam) => {
  return axios.get<void>("/internal-tool/v1/audit-logs", {
    params,
  });
};
